<template>
    <div>

        <rkm-area
            type="fieldset"
            title="Filtros"
        >

            <rkm-form
                ref="Form"
            >

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :max-date="data.form.dataAtual"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="agendamentoExame"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleExame()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="auto">
                        <rkm-form-checkbox-group
                            label="Status"
                            v-model="model.statusId"
                            :options="model.status"
                            :validations="validations.status"
                            text-field="nome"
                            value-field="id"
                            buttons
                            button-color="outline-primary"
                            @change="handleExame()"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            label="Agendamento"
                            v-model="model.agendamentoNumero"
                            number
                            @blur="handleAgendamento()"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                            :repository="repositories.paciente"
                            v-model="paciente"
                            :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                            label="Paciente"
                            uppercase
                            @select="handlePaciente()"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Prontuário"
                            v-model="model.prontuario"
                            number
                            @blur="handleProntuario()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeSolicitante"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            @change="handleUnidadeSolicitante()"
                            default-option-text="Todas"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            textField="nome"
                            v-model="model.infraestruturaId"
                            valueField="id"
                            show-default-option
                            @change="handleUnidadeSolicitante()"
                            default-option-text="Todos"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeColeta"
                            label="Local de coleta"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.coletaUnidadeId"
                            value-field="unidadeId"
                            default-option-text="Todas"
                            @change="handleColeta()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="coletaInfraestruturas"
                            textField="nome"
                            v-model="model.coletaInfraestruturaId"
                            valueField="id"
                            show-default-option
                            default-option-text="Todos"
                            @change="handleColeta()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeLaboratorio"
                            label="Laboratório"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.laboratorioId"
                            value-field="unidadeId"
                            default-option-text="Todos"
                            @change="setListagem()"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="laboratorioInfraestruturas"
                            textField="nome"
                            v-model="model.laboratorioInfraestruturaId"
                            valueField="id"
                            show-default-option
                            default-option-text="Todos"
                            @change="setListagem()"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="itemsNotSave"
            no-margin-top
            title="Resultado"
        >

            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    :disabled="itemsNotSave.length === 0"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>
                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>
                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                    :disabled="itemsNotSave.length === 0"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itemsNotSave.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
        </rkm-area>

        <template>

            <div
                v-for="(item, index) in itemsNotSave"
                class="mb-3"
                :key="index"
            >

                <rkm-table
                    :items="item.exames"
                    :fields="fields"
                    hide-filters
                    sort-by="dataAgendamento"
                    :sort-compare="sortCompare"
                    hide-pagination
                    class="table-agendamento"
                >
                    <template #thead-top>

                        <rkm-tr>
                            <rkm-th
                                :colspan="selectedCols.length + 5"
                            >
                                Paciente: {{ item.pacienteNome }}
                                <span v-if="item.pacientePreferenciaNome">
                                    <strong>({{ item.pacienteNomeSocial }})</strong>
                                </span>
                                - Prontuário: {{ item.pacienteProntuario }}
                                - Data de nascimento: {{ item.pacienteNascimento }}
                            </rkm-th>
                        </rkm-tr>
                    </template>

                    <template v-slot:cell(dataAgendamento)="{ item }">
                        {{ item.dataAgendamento.split("-").reverse().join("/") }}
                    </template>

                    <template v-slot:custom-foot>
                        <tr>
                            <td class="table-td"></td>
                            <td class="table-td" :colspan="selectedCols.length + 2">
                                Total Exames: {{ item.total.quantidade }}
                            </td>
                            <td class="table-td col-min text-center">
                                Valor médio:  {{ item.total.valorMedio }}
                            </td>
                            <td class="table-td col-min text-center">
                                Total:  {{ item.total.valorTotal }}
                            </td>
                        </tr>
                    </template>
                </rkm-table>
            </div>
        </template>

        <template>
            <rkm-row v-if="itemsNotSave && itemsNotSave.length > 0">

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Total"
                        type="fieldset"
                    >
                        <rkm-row>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Exames"
                                    :disabled="true"
                                    v-model="model.total.quantidade"
                                />
                            </rkm-col>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Valor médio"
                                    :disabled="true"
                                    v-model="model.total.valorMedio"
                                />
                            </rkm-col>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Total geral"
                                    :disabled="true"
                                    v-model="model.total.valorTotal"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </template>

        <template>
            <rkm-table
                v-if="itemsNotSave && itemsNotSave.length == 0"
                :items="itemsNotSave"
                :fields="fields"
                hide-filters
                sort-by="nome"
                hide-pagination
            />
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                status: { required: true },
            }
        },
        infraestruturas() {

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        coletaInfraestruturas() {

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        laboratorioInfraestruturas() {

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.relatorioFinanceiroPaciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                agendamentoNumero: null,
                prontuario: null,
                unidadeId: null,
                infraestruturaId: null,
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                laboratorioId: null,
                laboratorioInfraestruturaId: null,
                pacienteId: null,
                exameId: null,
                exameNome: null,
                grupos: null,
                status: [],
                statusId: [],
                statusSelecionado: [],
                periodo: {
                    start: null,
                    end: null,
                },
                totalExame: 0,
                totalValorMedio: 0,
                totalValor: 0,
            },
            paciente: null,
            agendamentoExame: [],
            unidadeSolicitante: [],
            unidadeColeta: [],
            unidadeLaboratorio: [],
            itemsNotSave: [],
            items: [],
            total: [],
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            indeterminate: false,
            filterDefault: {},
            selectedAll: false,
            columns: [
                { key: 'dataAgendamento', label: 'Data agendamento', sortable: true, class: 'col-min text-center', fixed: true },
                { key: 'exameNome', label: 'Exame', sortable: true, fixed: true },
                { key: 'procedimento', label: 'Procedimento', fixed: true },
                { key: 'agendamentoNumero', label: 'Agendamento', sortable: true, class: 'col-min text-center' },
                { key: 'status', label: 'Status', sortable: true, class: 'col-min' },
                { key: 'unidade', label: 'Unidade solicitante' },
                { key: 'infraestruturaNome', label: 'Local de atendimento solicitante', sortable: true },
                { key: 'unidadeColeta', label: 'Unidade coleta' },
                { key: 'coletaInfraestruturaNome', label: 'Local de atendimento coleta', sortable: true },
                { key: 'laboratorio', label: 'Laboratório' },
                { key: 'laboratorioInfraestruturaNome', label: 'Local de atendimento laboratório', sortable: true },
                { key: 'valorUnitario', label: 'Valor unitário', class: 'col-min text-center', fixed: true },
                { key: 'valorTotal', label: 'Valor total', class: 'col-min text-center', fixed: true },
            ],
            selectedCols: [],
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'dataAgendamento') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {

            this.model.periodo = this.data.form.periodo

            this.setStatus()
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioFinanceiroPaciente(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioFinanceiroPaciente(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            if (this.paciente) {

                data.pacienteId = this.paciente.id
                data.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.exameId) {

                data.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

                data.unidadeNome = this.data.form.unidades.find(u => u.id == data.unidadeId).nomeFantasia
            }

            if (data.infraestruturaId) {

                data.infraestruturaNome = this.infraestruturas.find(u => u.id == data.infraestruturaId).nome
            }

            if (data.coletaUnidadeId) {

                data.coletaUnidadeNome = this.unidadeColeta.find(u => u.unidadeId == data.coletaUnidadeId).nomeFantasia
            }

            if (data.coletaInfraestruturaId) {

                data.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == data.coletaInfraestruturaId).nome
            }

            if (data.laboratorioId) {

                data.laboratorioNome = this.unidadeLaboratorio.find(u => u.unidadeId == data.laboratorioId).nomeFantasia
            }

            if (data.laboratorioInfraestruturaId) {

                data.laboratorioInfraestruturaNome = this.laboratorioInfraestruturas.find(u => u.id == data.laboratorioInfraestruturaId).nome
            }

            data.statusId.forEach(status => {

                const selecionado = data.status.find(u => u.id == status)

                if (status) {

                    data.statusSelecionado.push({

                        id: selecionado.id,
                        nome: selecionado.nome,
                    })
                }
            })

            this.formateDates(data.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        search() {

            this.setLoading()

            this.repositories.exame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                    this.model.total = data.model.total
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exameId = null
            this.paciente = null
            this.model.pacienteId = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.itemsNotSave = null

            this.setStatus()
            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setStatus() {

            this.model.statusId = [
                this.enums.statusAgendamento.AGENDADO,
                this.enums.statusAgendamento.REALIZADO,
                this.enums.statusAgendamento.DUPLICIDADE,
                this.enums.statusAgendamento.OUTROS,
            ]

            this.model.status = [
                {
                    "id": this.enums.statusAgendamento.AGENDADO,
                    "nome": "AGENDADO",
                },
                {
                    "id": this.enums.statusAgendamento.REALIZADO,
                    "nome": "COLETA REALIZADA",
                },
                {
                    "id": this.enums.statusAgendamento.DUPLICIDADE,
                    "nome": "DUPLICIDADE",
                },
                {
                    "id": this.enums.statusAgendamento.OUTROS,
                    "nome": "OUTROS",
                },
            ]
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        setListagem() {

            this.itemsNotSave = null
            this.items = []
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {

                this.model.infraestruturaId = null
            }
        },
        handleColetaInfraestrutura(infraestruturaColetaPrincipal) {

            if (infraestruturaColetaPrincipal.find(u => u.principal === true)) {

                this.model.coletaInfraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal === true).id
            }
        },
        handleLaboratorioInfraestrutura(infraestruturaLaboratorioPrincipal) {

            if (infraestruturaLaboratorioPrincipal.find(u => u.principal === true)) {

                this.model.laboratorioInfraestruturaId = infraestruturaLaboratorioPrincipal.find(u => u.principal === true).id
            }
        },
        setInfraestrutura() {

            this.model.infraestruturaId = null
        },
        setColetaInfraestrutura() {

            this.model.coletaInfraestruturaId = null
        },
        setLaboratorioInfraestrutura() {

            this.model.laboratorioInfraestruturaId = null
        },
        loadFields() {

            this.setLoading()
            this.setListagem()

            this.repositories.exame.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.model.unidades)
                    this.loadUnidadeColeta(data.model.coletas)
                    this.loadLaboratorio(data.model.laboratorios)
                    this.loadExame(data.model.exames)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(agendamento) {

            const unidades = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.unidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.infraestruturaId).principal

                const unidadeInserida = unidades.find(u => u.unidadeId
                    === infraestrutura.unidadeId)

                if (unidadeInserida) {

                    let verifyUnidade = unidadeInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.infraestruturaId)

                    if (!verifyUnidade) {

                        unidadeInserida.infraestruturas.push({

                            id: infraestrutura.infraestruturaId,
                            nome: infraestrutura.infraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    unidades.push({

                        unidadeId: infraestrutura.unidadeId,
                        nomeFantasia: infraestrutura.unidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeSolicitante = unidades

            if (unidades.length === 1) {
                this.model.unidadeId = unidades[0].unidadeId
            }
        },
        loadUnidadeColeta(agendamento) {

            const coleta = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.coletaUnidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.coletaInfraestruturaId).principal

                const coletaInserida = coleta.find(u => u.unidadeId
                    === infraestrutura.coletaUnidadeId)

                if (coletaInserida) {

                    let verifyUnidade = coletaInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.coletaInfraestruturaId)

                    if (!verifyUnidade) {

                        coletaInserida.infraestruturas.push({

                            id: infraestrutura.coletaInfraestruturaId,
                            nome: infraestrutura.coletaUnidadeNome,
                            principal: principal,
                        })
                    }

                } else {

                    coleta.push({

                        unidadeId: infraestrutura.coletaUnidadeId,
                        nomeFantasia: infraestrutura.coletaUnidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.coletaInfraestruturaId,
                                nome: infraestrutura.coletaInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeColeta = coleta

            if (coleta.length === 1) {
                this.model.coletaUnidadeId = coleta[0].unidadeId
            }
        },
        loadLaboratorio(agendamento) {

            const laboratorio = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.laboratorioId).infraestruturas.find(u => u.id
                        === infraestrutura.laboratorioInfraestruturaId).principal

                const laboratorioInserida = laboratorio.find(u => u.unidadeId
                    === infraestrutura.laboratorioId)

                if (laboratorioInserida) {

                    let verifyUnidade = laboratorioInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.laboratorioInfraestruturaId)

                    if (!verifyUnidade) {

                        laboratorioInserida.infraestruturas.push({

                            id: infraestrutura.laboratorioInfraestruturaId,
                            nome: infraestrutura.laboratorioInfraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    laboratorio.push({

                        unidadeId: infraestrutura.laboratorioId,
                        nomeFantasia: infraestrutura.unidadeLaboratorioNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.laboratorioInfraestruturaId,
                                nome: infraestrutura.laboratorioInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeLaboratorio = laboratorio

            if (laboratorio.length === 1) {
                this.model.laboratorioId = laboratorio[0].unidadeId
            }
        },
        loadExame(exames) {

            const exameCadastrado = []

            exames.map(exame => {

                exameCadastrado.push({

                    id: exame.id,
                    nome: exame.nome,
                })
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        handlePeriodo() {

            this.model.exameId = null
            this.model.agendamentoNumero = null
            this.paciente = null
            this.model.pacienteId = null
            this.model.prontuario = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleExame() {

            this.model.agendamentoNumero = null
            this.paciente = null
            this.model.pacienteId = null
            this.model.prontuario = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleAgendamento() {

            this.model.unidadeId = null
            this.model.pacienteId = null
            this.paciente = null
            this.model.prontuario = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleProntuario() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handlePaciente() {

            this.model.prontuario = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleUnidadeSolicitante() {

            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleColeta() {

            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        }
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'paciente'() {

            this.handlePaciente()
        },
        'model.unidadeId'() {

            this.setInfraestrutura()

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                this.handleInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.coletaUnidadeId'() {

            this.setColetaInfraestrutura()

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                this.handleColetaInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.laboratorioId'() {

            this.setLaboratorioInfraestrutura()

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                this.handleLaboratorioInfraestrutura(infraestruturaPrincipal)
            }
        },
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-agendamento >>> .col-width {
    width: 16%;
}
</style>